import { render, staticRenderFns } from "./DisputeView.vue?vue&type=template&id=3dbf8cbf&"
import script from "./DisputeView.vue?vue&type=script&lang=js&"
export * from "./DisputeView.vue?vue&type=script&lang=js&"
import style0 from "./DisputeView.vue?vue&type=style&index=0&id=3dbf8cbf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports